<template>
  <div class="activeConversationNotSelectedMessage" :style="cssProps">
    <div class="specLogo">
      <img :src="organizationLogo">
    </div>
    <div class="midImage">
      <img src="@/assets/images/cmptr.rekabet.png">
    </div>
    <div class="subTitle">
      Sürekli iletişimde olun!
    </div>
    <div class="subTitleInfo">
      <p>
        {{appDisplayName}} web mesaj uygulaması, mobil uygulama ile senkron bir şekilde çalışır.
      </p>
      <p>{{appDisplayName}} kullanarak kurum içinde verimliliğiniz arttırın.</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      appName: process.env.APPNAME,
      appDisplayName: process.env.APPDISPLAYNAME
    }
  },
  computed: {
    cssProps () {
      return {
        '--bottomBorderColor': this.$config.theme.default.homePage.bottomBorderColor
      }
    },
    organizationLogo () {
      return this.$config.theme.default.loginPage.organizationLogo
    }
  }
}
</script>

<style scoped>
.activeConversationNotSelectedMessage {
  position: absolute;
  width: 100%;
  height: calc(100% - 24px);
  padding-top: 20px;
  text-align: center;
  color: rgb(0, 0, 0);
  background-color: #f7f9fa;
  border-bottom: 4px solid var(--bottomBorderColor);
}

.specLogo {
  text-align: right;
}

.midImage {
  padding-top: 50px;
}

.specLogo > img {
  width: 170px;
  margin-right: 40px;
}

.subTitle {
  padding-top: 20px;
  font-weight: 400;
  font-size: 25px;
}

.subTitleInfo {
  padding-top: 20px;
  font-weight: 300;
  font-size: 15px;
  color: #4e4e4e;
}
</style>
